import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {EnvironmentService} from "@iw-shop/core//services/environment.service";
import {Store} from "@ngrx/store";
import {AppState} from "@store/state/app.state";
import {ApiArticleRecommendationsGetRequest, ApiArticleRecommendationsGetResponse} from "@api/article-recommandations";

@Injectable({
  providedIn: 'root'
})
export class ArticleRecommendationService {

  constructor(private http: HttpClient, private environmentService: EnvironmentService) {

  }

  get(articleNumber: string): Observable<ApiArticleRecommendationsGetResponse> {
    const body: ApiArticleRecommendationsGetRequest = {
      id: 'getArticleRecommendations',
      command: 'articleRecommendations/get',
      params: {
        filters: [
          {fields: ['articleNumber'], values: [articleNumber]}
        ],
        articleRecommendations: {}
      }
    };
    return this.http.post<ApiArticleRecommendationsGetResponse>(this.environmentService.environment.urlApi, JSON.stringify(body));
  }
}
